import { deepAddParent } from '../../core/functions/deep-add-parent.js';
import { RG_TYPE } from '../../types/rg-type.js';
import { getRgObjectsOfType } from '../../utils/get-rg-objects-of-type.js';
import { dtoToBuilding } from './internal/building/dto-to-building.js';
import { TypesWithClipperPoly, dtoTypeWithClipperPoly } from './internal/types-with-polygon-data/dto-to-type-with-clipper-poly.js';
import { dtoToPlot } from './internal/plot/dto-to-plot.js';
import { dtoToZone } from './internal/zone/dto-to-zone.js';

function dtoToRgObject(dto, config) {
    if (!config)
        config = {};
    const { versions = dto.versions, partials, top = true } = config;
    if (!partials && dto.type === RG_TYPE.Building)
        return dtoToBuilding(dto, versions);
    if (!partials && dto.type === RG_TYPE.Zone)
        return dtoToZone(dto, versions);
    if (!partials && dto.type === RG_TYPE.Plot)
        return dtoToPlot(dto, versions);
    if (!partials && TypesWithClipperPoly.includes(dto.type))
        return dtoTypeWithClipperPoly(dto, versions);
    const rgObj = {
        rg: true,
        templateUuid: undefined,
        hash: undefined,
        modulousId: dto.modulousId,
        name: dto.name,
        uuid: dto.uuid,
        type: dto.type,
        pos: dto.pos,
        rot: dto.rot,
        size: dto.size,
        anchor: dto.anchor,
        color: dto.color,
        alpha: dto.alpha,
        data: partials?.data ?? dto.data,
        ...partials,
        children: partials?.children ?? dto.children.map(c => dtoToRgObject(c, { versions, top: false }))
    };
    if (top) {
        // restore apartment children from templates
        const templates = dto.templates.map(t => dtoToRgObject(t, { versions, top: false }));
        const templatesMap = new Map(templates.map(t => [t.name, t]));
        const apartments = getRgObjectsOfType(rgObj, RG_TYPE.Apartment);
        for (const unit of apartments) {
            unit.children = templatesMap.get(unit.name).children;
        }
        // assign parents
        deepAddParent(rgObj);
    }
    return rgObj;
}

export { dtoToRgObject };
//# sourceMappingURL=dto-to-rg-object.js.map
